/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Propagation rules used when a node's availability changes to determine
 * how dependent nodes should react.
 */
enum PropagationRule {
  /**
   * Target immediately adopts the source's new availability
   * (subject to the target's setAvailability() conditional logic).
   * Used when parent certainty transfers (e.g., LAN down → Internet certainly down).
   */
  PROPAGATE = "PROPAGATE",

  /**
   * Target independently re-validates its own connectivity from scratch.
   * Used when parent state change does not guarantee child state
   * (e.g., LAN up does not mean Internet up).
   */
  RE_EVALUATE = "RE_EVALUATE"
}

/**
 * Configuration for how a dependent node should react when the source
 * node's availability changes.
 */
interface DependencyConfig {
  /** Rule to apply when the source node becomes unavailable. */
  onUnavailable: PropagationRule;
  /** Rule to apply when the source node becomes available. */
  onAvailable: PropagationRule;
}

export { PropagationRule };
export type { DependencyConfig };
